export const initialState = {
    startWeekDate: null,
    endWeekDate: null,
    rewardsGained: 0,
    rewardsPlanned: 0,
    isLoading: false,
    error: null,
};
